import { format, parseISO } from "date-fns";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
// import { Helmet } from "react-helmet";
import info from "../../../images/info.png";
import invester from "../../../images/Investor.png";
import animation from "../../../images/jm-animation.gif";
import partner from "../../../images/partner.png";
import URLstateContext from "../../../provider/CommonContext";
import {
  DecryptAESdata,
  GetPostMethodData,
} from "../../../provider/ServiceProvider";
import "../ProductSheme/ProductSheme.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import ProductBanner from "../ProductBanner/ProductBanner";
import NewProductsBanner from "../NewProductsBanner/NewProductsBanner";
// import { useNavigate } from "react-router-dom";
function ProductSheme() {
  const navigate = useNavigate();
  const { category } = useParams();
  const [valuebtn, SetValue] = useState(category || "");
  // alert(valuebtn)
  // const socialIconsRef = useRef(null);
  const [currentPopupId, setCurrentPopupId] = useState("");
  const [SearchText, setSearchText] = useState("");
  const [SearchData, setSearchData] = useState([]);
  const [showMatrix, setShowMatrix] = useState(false);
  const [showRiskMatrix, setShowRiskMatrix] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [pathname, setPathName] = useState("");
  const [loadingshow, setloadingshow] = useState(false);
  const socialIconsRef = useRef(null);
  const socialIconsRefinvest = useRef(null);
  const [SearchImage, setSearchImage] = useState([]);
  let DataFilter = [];
  const regEx = new RegExp("-", "g");
  const [isToggleOn, setToggleOn] = useState("Regular");
  const [announcement, setAnnouncement] = useState("");
  const investDropdownRef = useRef(null);
const investButtonRef = useRef(null);
  // alert(isToggleOn)
  const handleClick = () => {
    setToggleOn((prevState) =>
      prevState === "Regular" ? "Direct" : "Regular",
    );
  };

  useEffect(() => {
  if (loadingshow) {
    setAnnouncement("Please wait. Loading data.");
  } else if (SearchText) {
    if (SearchData?.length > 0) {
      setAnnouncement(
        `${SearchData.length} results found for ${SearchText}`
      );
    } else {
      setAnnouncement(
        `No results found for ${SearchText}`
      );
    }
  }
}, [loadingshow, SearchData, SearchText]);


  useEffect(() => {
    // Keep local state in sync with URL
    SetValue(category || "");
  }, [category]);

  const handleUrlClick = (value) => {
    SetValue(value);
    navigate(`/products/${value || ""}`); // updates URL without reload
  };
  const [data, setData] = useState([]);
  const { BaseURL } = useContext(URLstateContext);

  

  const [CategoryIdUrl, SetCategoryIdUrl] = useState("");
  //  alert(CategoryIdUrl)
  const handleInvestButtonClick = () => {
    // window.open("https://investor.jmfinancialmf.com/jmfinvestor/", "_blank");
    document.getElementById("myModal").style.display = "block";
  };

  
  useEffect(() => {
    setShowRiskMatrix(false);
    // document.getElementsByClassName('potentioal-hover').style.display = "none";
    // const pathname = window.location.pathname;
    // const segments = pathname.split('/').filter(segment => segment !== '');
    // const lastSegment = segments[segments.length - 1];
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(capitalizeWords(CategoryIdUrlid));
    // alert(CategoryIdUrlid)
    if (CategoryIdUrlid === "all-mutual-fund-schemes") {
      SetCategoryIdUrl("");
      SetValue("");
    } else if (CategoryIdUrlid === "equity-schemes") {
      SetCategoryIdUrl("Equity");
      SetValue("Equity");
    } else if (CategoryIdUrlid === "fixed-income") {
      SetCategoryIdUrl("debt");
      SetValue("debt");
    } else if (CategoryIdUrlid === "hybrid-schemes") {
      SetCategoryIdUrl("Hybrid");
      SetValue("Hybrid");
    }
  }, [CategoryIdUrl]);

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetNAVDetails", {
      type: valuebtn,
      IVSchemeType: isToggleOn,
      IVOuput: "",
      IVFundSearch: SearchText,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setSearchData(DecryptAESdata(data.data));

        setloadingshow(false);
        //  alert(data)
        setShowRiskMatrix(valuebtn === "debt");
      } else {
        setSearchData([]);
        setloadingshow(false);
      }
    });
  }, [BaseURL, valuebtn, isToggleOn, SearchText]);

  // useEffect(()=>{
  //   setloadingshow(true)
  //   GetPostMethodData(BaseURL + "GetDynamicURLData", {

  //   })
  // })

  // function HTMLRenderer({ htmlContent }) {
  //   return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
  // }

  // const handleFormChangeEquity = (index, DrpPeriod) => {
  //     var period = DrpPeriod.target.value;
  //     // alert(period, "period")
  //     var PeriodValue = period.split("~");
  //     document.getElementById("EquityInvestmentReturnsDiv" + index).innerText =
  //         PeriodValue[1] + "%";
  // };
  
  const handleFormChangeEquity = (index, DrpPeriod) => {
    var period = DrpPeriod.target.value;
    if (document.getElementById("return7D" + index) != null) {
      document.getElementById("return7D" + index).style.display = "none";
    }
    if (document.getElementById("return15D" + index) != null) {
      document.getElementById("return15D" + index).style.display = "none";
    }
    if (document.getElementById("return30D" + index) != null) {
      document.getElementById("return30D" + index).style.display = "none";
    }
    if (document.getElementById("return3M" + index) != null) {
      document.getElementById("return3M" + index).style.display = "none";
    }
    if (document.getElementById("return6M" + index) != null) {
      document.getElementById("return6M" + index).style.display = "none";
    }
    document.getElementById("return1Y" + index).style.display = "none";
    document.getElementById("return3Y" + index).style.display = "none";
    document.getElementById("return5Y" + index).style.display = "none";
    document.getElementById("return10Y" + index).style.display = "none";
    document.getElementById("returnSince" + index).style.display = "none";
    document.getElementById("return" + period).style.display = "inline";
  };
  function handleInputChange(event) {
    let Blogdata = event.target.value;
    if (Blogdata) {
      setSearchText(Blogdata);
    } else {
      DataFilter = [];
      setSearchText("");
    }
  }

  const clickGetSchemes = (event) => {
    const schemeId = event.currentTarget.dataset.id;

    const schemeType = event.currentTarget.dataset.type;
    // alert(schemeType)
    const schemeName = event.currentTarget.dataset.name;
    // alert(schemeName)
    const schemeDesc = event.currentTarget.dataset.disc;
    // alert(schemeDesc)

    window.open(
      "/products/" +
        schemeType.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeName.replace(/ /g, "-").replace("&", "and").replace("+", "") +
        "/" +
        schemeId +
        "/" +
        schemeDesc.replace(/ /g, "-").replace("&", "and"),
      "_self",
    );
    // alert(`SchemeID : ${schemeId}, SchmeType : ${schemeType}, SchemeName: ${schemeName}, schemeDesc: ${schemeDesc}`)
  };

  function YourComponent({ SearchData }) {
    // Create a function to group data by SchemeCode
    const groupDataBySchemeCode = (data) => {
      const groupedData = {};

      data.forEach((item) => {
        const schemeCode = item.SchemeCode;
        if (!groupedData[schemeCode]) {
          groupedData[schemeCode] = [];
        }
        groupedData[schemeCode].push(item);
      });

      return groupedData;
    };

    // Group the data by SchemeCode
    const groupedData = groupDataBySchemeCode(SearchData);
  }
  function capitalizeWords(str) {
    return str.replace(/\b\w/g, (match) => match.toUpperCase());
  }
  const sendMassage = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    const fetchImage = e.currentTarget.getAttribute("data-img");
    setSearchImage(fetchImage);
    const popupId = "q_" + fetchId.split("_")[1];
    const popup = document.getElementById(popupId);
    const isSamePopup = currentPopupId === popupId;

    if (currentPopupId) {
      const currentPopup = document.getElementById(currentPopupId);
      if (currentPopup) {
        currentPopup.style.display = isSamePopup ? "none" : "none";
      }
    }

    if (!isSamePopup) {
      popup.style.display = "flex";
      setCurrentPopupId(popupId);
    } else {
      setCurrentPopupId(null);
    }
  };

  const getDisplayName = (category) => {
    switch (category) {
      case "Equity":
        return "Equity";
      case "Hybrid":
        return "Hybrid";
      case "debt":
        return "Fixed Income";
      default:
        return category || "All";
    }
  };

  // if(!isValidPage){
  //   return <NotFound/>
  // }

  //   const getRiskColor = (risk) => {
  //   switch (risk) {
  //     case "Very High":
  //       return "#f70d1a";
  //     case "Low":
  //       return "#08a04b";
  //     case "Low to Moderate":
  //       return "#7fff00";
  //     case "Moderate":
  //       return "#ffff33";
  //     default:
  //       return "#000"; // fallback
  //   }
  // };


  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      investDropdownRef.current &&
      !investDropdownRef.current.contains(event.target) &&
      investButtonRef.current &&
      !investButtonRef.current.contains(event.target)
    ) {
      // Hide the dropdown
      document.querySelectorAll(".link-div-invest").forEach((el) => {
        el.style.display = "none";
      });
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);


  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Discover a wide range of mutual fund products from JM Financial Mutual Fund. Choose from equity, debt, and hybrid schemes tailored to meet diverse investment goals."
          />
          <meta
            name="keywords"
            content="jmf_products_landing, JM Financial Mutual Fund, mutual fund products, investment products"
          />
          <title>
            Explore Mutual Fund Products | Equity, Debt & Hybrid Schemes | JM
            Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

      <NewProductsBanner />

      <main className="product-main" id="main-content" tabIndex="-1">
        <h1 className="sr-only">Products</h1>
        <section className="product-section margin-top">
          <Container>
            <Row>
              <Col>
                <div class="col-12 p-0 breadcrum ">
                  <nav aria-label="Breadcrumb">
                    <ul className="navigator-arrow">
                      <li>
                        <a href="/" aria-label="Home">
                          {/* <i class="fa fa-home" aria-hidden="true"></i> */}
                          <span>
                            <i className="fa fa-home"></i>
                          </span>
                          <span className="sr-only"> Home </span>
                        </a>{" "}
                        {/* <i class="fa fa-angle-right" aria-hidden="true"></i> */}
                        <span>
                          <i className="fa fa-angle-right"></i>
                        </span>
                      </li>
                      <li>
                        <a href="/products">Products</a>{" "}
                        {/* <i class="fa fa-angle-right" aria-hidden="true"></i> */}
                        <span>
                          <i className="fa fa-angle-right"></i>
                        </span>
                      </li>
                      {/* <li>Calculator</li><i class="fa fa-angle-right" aria-hidden="true"></i> */}
                      {/* {window.location.pathname != "/products" ? (
                      <li>{capitalizeWords(pathname.replace("-", " "))}</li>
                    ) : (
                      <>
                        {valuebtn != "debt" ? (
                          <li>{valuebtn != "" ? valuebtn : "All"}</li>
                        ) : (
                          "Fixed Income"
                        )}
                      </>
                    )} */}
                      {/* {window.location.pathname !== "/products" ? (
                      <li>{capitalizeWords(pathname.replace("-", " "))}</li>
                    ) : category ? (
                      <li>{getDisplayName(valuebtn)}</li>
                    ) : (
                      <li>All</li>
                    )} */}
                      {category ? (
                        <li>{getDisplayName(valuebtn)}</li>
                      ) : (
                        <li>All</li>
                      )}
                    </ul>
                  </nav>
                </div>
              </Col>
            </Row>
          </Container>

          <Container>
            <Row>
              <Col sm={12}>
                <div className="btn-sch-prod">
                  <div className="tab-button" role="tablist">
                    <button
                      id="tab-all"
                      role="tab"
                      className={valuebtn === "" ? "active" : ""}
                      value=""
                      onClick={(event) => {
                        const val = event.target.value;
                        SetValue(val);
                        if (val) {
                          navigate(`/products/${val}`);
                        } else {
                          navigate(`/products`);
                        }
                        // navigate(`/products/${val}`); // <-- this updates the URL
                      }}
                      // aria-label="all funds button"
                      aria-selected={valuebtn === ""}
                      // aria-controls="tabpanel-products"
                    >
                      All
                    </button>
                    <button
                      id="tab-equity"
                      role="tab"
                      aria-selected={valuebtn === "Equity"}
                      // aria-controls="tabpanel-products"
                      className={valuebtn === "Equity" ? "active" : ""}
                      value="Equity"
                      onClick={(event) => {
                        const val = event.target.value;
                        SetValue(val);
                        if (val) {
                          navigate(`/products/${val}`);
                        } else {
                          navigate(`/products`);
                        }
                        // navigate(`/products/${val}`); // <-- this updates the URL
                      }}
                      // aria-label="equity funds"
                    >
                      Equity
                    </button>
                    <button
                      id="tab-fixed-income"
                      role="tab"
                      aria-selected={valuebtn === "debt"}
                      // aria-controls="tabpanel-products"
                      className={valuebtn === "debt" ? "active" : ""}
                      value="debt"
                      onClick={(event) => {
                        const val = event.target.value;
                        SetValue(val);
                        if (val) {
                          navigate(`/products/${val}`);
                        } else {
                          navigate(`/products`);
                        }
                        // navigate(`/products/${val}`); // <-- this updates the URL
                      }}
                      // aria-label="fixed income funds"
                    >
                      Fixed Income
                    </button>
                    <button
                      id="tab-hybrid"
                      role="tab"
                      aria-selected={valuebtn === "Hybrid"}
                      // aria-controls="tabpanel-products"
                      className={valuebtn === "Hybrid" ? "active" : ""}
                      value="Hybrid"
                      onClick={(event) => {
                        const val = event.target.value;
                        SetValue(val);
                        navigate(`/products/${val}`); // <-- this updates the URL
                      }}
                      // aria-label="hybrid funds"
                    >
                      Hybrid
                    </button>
                  </div>
                  <div className="form-group-container mb-0">
                    <div className="form-group search-input mb-0">
                      <label htmlFor="SearchBlogs" className="sr-only">
                        Search Scheme
                      </label>
                      <input
                        type="text"
                        className="search-product"
                        name="SearchBlogs"
                        onChange={handleInputChange}
                        id="SearchBlogs"
                        placeholder="Search Scheme..."
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  {/* <div>
                    <div className="toggle-swich-container">
                      <span>Direct</span>
                      <div
                        onClick={handleClick}
                        className={`ToggleSwitch ${isToggleOn === "Regular" ? "active" : ""
                          }`}
                      >
                        <button
                          value={isToggleOn}
                          onClick={(event) => {
                            event.stopPropagation();
                          }}
                          className={`knob ${isToggleOn === "Regular" ? "active" : ""
                            }`}
                        ></button>
                      </div>
                      <span>Regular</span>
                    </div>

                    
                  </div> */}
                  {/* <div className="toggle-swich-container-treading">
                    <span>Direct Plan</span>
                    <button
                    type="button"
                      role="switch"
                      aria-checked={isToggleOn === "Regular"}
                      aria-label={
                          isToggleOn === "Regular"
                            ? "Regular plan selected. Switch to Direct plan"
                            : "Direct plan selected. Switch to Regular plan"
                        }
                      onClick={handleClick}
                      className={`toggle-switch ${
                        isToggleOn === "Regular" ? "active" : ""
                      }`}
                    >
                      <a
                        value={isToggleOn}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        className={`knob ${
                          isToggleOn === "Regular" ? "active" : ""
                        }`}
                      ></a>
                    </button>
                    <span>Regular Plan</span>
                  </div> */}
                  <div className="toggle-swich-container-treading">
                    <span>Direct Plan</span>

                    <button
                      type="button"
                      role="switch"
                      aria-checked={isToggleOn === "Regular"}
                      aria-label={
                        isToggleOn === "Regular"
                          ? "Regular plan selected. Switch to Direct plan"
                          : "Direct plan selected. Switch to Regular plan"
                      }
                      onClick={handleClick}
                      className={`toggle-switch ${
                        isToggleOn === "Regular" ? "active" : ""
                      }`}
                    >
                      <span
                        className={`knob ${
                          isToggleOn === "Regular" ? "active" : ""
                        }`}
                        // aria-hidden="true"
                      ></span>
                    </button>

                    <span>Regular Plan</span>
                  </div>
                </div>
                <div className="tab-content">
                  <div id="equity">
                    <div className="product-container">
                      {/* {loadingshow ? (
                        <div className="textcentervertex HomeLoader">
                          <img src={animation} alt="Loading" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        <div>
                          {SearchData.length === 0 ? (
                            <h5 className="errormsgComNew">No Data Available</h5>
                          ) : ( */}
                      <>
                        <div
                          className="product-box-container"
                          style={{ position: "relative" }}
                        >
                          {/* {(SearchText && !SearchData || SearchData.length === 0  ) && (
                         <h6 className="errorMsg">No Data Found !!!</h6>
                               )} */}
                          <div
                            aria-live="polite"
                            aria-atomic="true"
                            className="sr-only"
                          >
                            {announcement}
                          </div>
                          {loadingshow ? (
                            <div
                              className="textcentervertex lodecenter"
                              role="status"
                              aria-live="polite"
                              aria-busy="true"
                            >
                              <img src={animation} alt="" aria-hidden="true" />
                              <div className="model_popup">Please Wait...</div>
                            </div>
                          ) : (
                            <>
                              {((SearchText && !SearchData) ||
                                (Array.isArray(SearchData) &&
                                  SearchData.length === 0)) && (
                                <h6 className="errorMsg" role="alert">
                                  No Data Found !!!
                                </h6>
                              )}
                            </>
                          )}

                          {Array.isArray(SearchData) &&
                            SearchData.map(
                              (
                                {
                                  PlanDesc,
                                  FundName,
                                  risk,
                                  NAV,
                                  NAVdate,
                                  categoryname,
                                  SchemeCode,
                                  CAGRInception,
                                  SAR6Mon,
                                  VOI6Mon,
                                  BSAR6Mon,
                                  VOIInception,
                                  BCAGRInception,
                                  BCAGR1Yr,
                                  CAGR1Yr,
                                  BCAGR3Yr,
                                  CAGR3Yr,
                                  BCAGR5Yr,
                                  SAR7D,
                                  SAR15D,
                                  SAR30D,
                                  SAR3Mon,
                                  CAGR5Yr,
                                  CAGR10Yr,
                                  riskimage,
                                  VOI1Yr,
                                  VOI3Yr,
                                  VOI5Yr,
                                  PrcRisk,
                                  riskimagehover,
                                  InvestmentHorizon,
                                  SchemeAsonDate,
                                  PercentChange,
                                },
                                index,
                              ) => (
                                <div className="product-box">
                                  <h2>
                                    {FundName}
                                    <div className="h3-help-text">
                                      {PlanDesc}
                                    </div>
                                    {/* <div className="h3-help-text">
                                    {InvestmentHorizon != null
                                      ? InvestmentHorizon
                                      : ""}
                                  </div> */}
                                  </h2>

                                  <hr aria-hidden="true"/>
                                  <div className="mid-data">
                                    <div className="annual-return-container">
                                      <div className="annual-return">
                                        <p className="scheme-returns">
                                          <span>Scheme Returns</span>
                                          <span> (CAGR) </span>
                                        </p>
                                        <div className="return-perc">
                                          <div
                                            className="perc"
                                            id={
                                              "EquityInvestmentReturnsDiv" +
                                              index
                                            }
                                          >
                                            {SAR7D != null ? (
                                              <div
                                                className="perc"
                                                style={{ display: "none" }} // Hide 6M by default
                                                id={"return7D" + index}
                                              >
                                                {SAR7D != null ? (
                                                  SAR7D + "%"
                                                ) : (
                                                  <p className="returns">
                                                    No returns yet, as the Fund
                                                    is less than a year old
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            {SAR15D != null ? (
                                              <div
                                                className="perc"
                                                style={{ display: "none" }} // Hide 6M by default
                                                id={"return15D" + index}
                                              >
                                                {SAR15D != null ? (
                                                  SAR15D + "%"
                                                ) : (
                                                  <p className="returns">
                                                    No returns yet, as the Fund
                                                    is less than a year old
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            {SAR30D != null ? (
                                              <div
                                                className="perc"
                                                style={{ display: "none" }} // Hide 6M by default
                                                id={"return30D" + index}
                                              >
                                                {SAR30D != null ? (
                                                  SAR30D + "%"
                                                ) : (
                                                  <p className="returns">
                                                    No returns yet, as the Fund
                                                    is less than a year old
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            {SAR3Mon != null ? (
                                              <div
                                                className="perc"
                                                style={{ display: "none" }} // Hide 6M by default
                                                id={"return3M" + index}
                                              >
                                                {SAR3Mon != null ? (
                                                  SAR3Mon + "%"
                                                ) : (
                                                  <p className="returns">
                                                    No returns yet, as the Fund
                                                    is less than a year old
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            {SAR6Mon != null ? (
                                              <div
                                                className="perc"
                                                style={{ display: "none" }} // Hide 6M by default
                                                id={"return6M" + index}
                                              >
                                                {SAR6Mon != null ? (
                                                  SAR6Mon + "%"
                                                ) : (
                                                  <p className="returns">
                                                    No returns yet, as the Fund
                                                    is less than a year old
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              ""
                                            )}

                                            <div
                                              className="perc"
                                              style={{
                                                display:
                                                  categoryname
                                                    .toLowerCase()
                                                    .includes("debt") ||
                                                  categoryname
                                                    .toLowerCase()
                                                    .includes("fixed income")
                                                    ? "block"
                                                    : "none",
                                              }}
                                              id={"return1Y" + index}
                                            >
                                              {(() => {
                                                const year = 1;

                                                return CAGR1Yr !== null &&
                                                  CAGR1Yr !== undefined &&
                                                  CAGR1Yr !== "" ? (
                                                  Number(CAGR1Yr).toFixed(2) +
                                                    "%"
                                                ) : (
                                                  <p className="returns">
                                                    Since the scheme has not
                                                    completed {year}{" "}
                                                    {year > 1
                                                      ? "years"
                                                      : "year"}{" "}
                                                    from the date of inception,
                                                    the data is not available.
                                                  </p>
                                                );
                                              })()}
                                            </div>
                                            <div
                                              className="perc"
                                              style={{
                                                display:
                                                  categoryname === "Equity" ||
                                                  categoryname === "Hybrid"
                                                    ? "block"
                                                    : "none",
                                              }} // Show 3Y for Equity/Hybrid, hide for Fixed Income
                                              id={"return3Y" + index}
                                            >
                                              {(() => {
                                                const year = 3;

                                                return CAGR3Yr !== null &&
                                                  CAGR3Yr !== undefined &&
                                                  CAGR3Yr !== "" ? (
                                                  Number(CAGR3Yr).toFixed(2) +
                                                    "%"
                                                ) : (
                                                  <p className="returns">
                                                    Since the scheme has not
                                                    completed {year}{" "}
                                                    {year > 1
                                                      ? "years"
                                                      : "year"}{" "}
                                                    from the date of inception,
                                                    the data is not available.
                                                  </p>
                                                );
                                              })()}
                                            </div>

                                            <div
                                              className="perc"
                                              style={{ display: "none" }} // Hide 5Y by default
                                              id={"return5Y" + index}
                                            >
                                              {(() => {
                                                const year = 5;

                                                return CAGR5Yr !== null &&
                                                  CAGR5Yr !== undefined &&
                                                  CAGR5Yr !== "" ? (
                                                  Number(CAGR5Yr).toFixed(2) +
                                                    "%"
                                                ) : (
                                                  <p className="returns">
                                                    Since the scheme has not
                                                    completed {year}{" "}
                                                    {year > 1
                                                      ? "years"
                                                      : "year"}{" "}
                                                    from the date of inception,
                                                    the data is not available.
                                                  </p>
                                                );
                                              })()}
                                            </div>

                                            <div
                                              className="perc"
                                              style={{ display: "none" }} // Hide 5Y by default
                                              id={"return10Y" + index}
                                            >
                                              {(() => {
                                                const year = 10;

                                                return CAGR10Yr !== null &&
                                                  CAGR10Yr !== undefined &&
                                                  CAGR10Yr !== "" ? (
                                                  Number(CAGR10Yr).toFixed(2) +
                                                    "%"
                                                ) : (
                                                  <p className="returns">
                                                    Since the scheme has not
                                                    completed {year}{" "}
                                                    {year > 1
                                                      ? "years"
                                                      : "year"}{" "}
                                                    from the date of inception,
                                                    the data is not available.
                                                  </p>
                                                );
                                              })()}
                                            </div>
                                            <div
                                              className="perc"
                                              style={{ display: "none" }} // Hide Since Inception by default
                                              id={"returnSince" + index}
                                            >
                                              {CAGRInception !== null &&
                                              CAGRInception !== undefined &&
                                              CAGRInception !== "" ? (
                                                Number(CAGRInception).toFixed(
                                                  2,
                                                ) + "%" // Ensure number format with 2 decimal places
                                              ) : (
                                                <p className="returns">
                                                  This Scheme is a new scheme
                                                  and hence does not have any
                                                  performance track record.
                                                </p>
                                              )}
                                            </div>
                                            <p className="text-xsm text-normal">
                                              As on -{" "}
                                              {SchemeAsonDate != null
                                                ? format(
                                                    parseISO(SchemeAsonDate),
                                                    "do MMM, yyyy",
                                                  )
                                                : "-"}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="date-container">
                                          <p className="text-xsm textNav">
                                            Nav as on{" "}
                                            {NAVdate
                                              ? format(
                                                  parseISO(NAVdate),
                                                  "do MMM, yyyy",
                                                )
                                              : "--"}
                                          </p>
                                        </div>
                                        <div className="amount-market">
                                          <span className="text-700">
                                            ₹{" "}
                                            <span className="text-700">
                                              {NAV !== null && NAV !== undefined
                                                ? Number(NAV).toLocaleString(
                                                    "en-IN",
                                                    {
                                                      minimumFractionDigits: 2,
                                                    },
                                                  )
                                                : "--"}
                                            </span>
                                          </span>
                                          {/* <span className={(PercentChange > 0)  ? "text-green textAmount" : "text-red textAmount"}>
                                                {PercentChange} %
                                                
                                            </span> */}
                                        </div>
                                      </div>
                                      <div className="select-div">
                                        {/* <select
                                          name="amount"
                                          id={"drpperiod-" + index}
                                          onChange={(event) =>
                                            handleFormChangeEquity(index, event)
                                          }
                                        >
                                          {SAR6Mon != null ? (
                                            <option
                                              value={"6M" + index}
                                              selected
                                            >
                                              6 Months
                                            </option>
                                          ) : (
                                            ""
                                          )}
                                          <option value={"1Y" + index}>
                                            1Y
                                          </option>
                                          <option value={"3Y" + index}>
                                            3Y
                                          </option>
                                          <option value={"5Y" + index}>
                                            5Y
                                          </option>
                                          <option value={"Since" + index}>
                                            Since Inception
                                          </option>
                                        </select> */}
                                        <select
                                          name="amount"
                                          id={"drpperiod-" + index}
                                          onChange={(event) =>
                                            handleFormChangeEquity(index, event)
                                          }
                                          aria-label={`Choose time period for ${FundName} returns`}
                                          autoComplete="off"
                                        >
                                          {/* 7 Days */}
                                          {SAR7D !== null &&
                                            SAR7D !== undefined &&
                                            SAR7D !== "" && (
                                              <option value={"7D" + index}>
                                                7 Days
                                              </option>
                                            )}

                                          {/* 15 Days */}
                                          {SAR15D !== null &&
                                            SAR15D !== undefined &&
                                            SAR15D !== "" && (
                                              <option value={"15D" + index}>
                                                15 Days
                                              </option>
                                            )}

                                          {/* 30 Days */}
                                          {SAR30D !== null &&
                                            SAR30D !== undefined &&
                                            SAR30D !== "" && (
                                              <option value={"30D" + index}>
                                                1 Month
                                              </option>
                                            )}

                                          {/* 3 Months */}
                                        
                                          {SAR3Mon !== null &&
                                            SAR3Mon !== undefined &&
                                            SAR3Mon !== "" && (
                                              <option value={"3M" + index}>
                                                3 Months
                                              </option>
                                            )}
                                          {/* 6 Months */}
                                          {SAR6Mon !== null &&
                                            SAR6Mon !== undefined &&
                                            SAR6Mon !== "" && (
                                              <option value={"6M" + index}>
                                                6 Months
                                              </option>
                                            )}

                                          <option
                                            value={"1Y" + index}
                                            selected={
                                              categoryname.toLowerCase() ===
                                                "debt" ||
                                              categoryname.toLowerCase() ===
                                                "fixed income"
                                            }
                                          >
                                            1Y
                                          </option>
                                          <option
                                            value={"3Y" + index}
                                            selected={
                                              categoryname === "Equity" ||
                                              categoryname === "Hybrid"
                                            }
                                          >
                                            3Y
                                          </option>
                                          <option value={"5Y" + index}>
                                            5Y
                                          </option>
                                          <option value={"10Y" + index}>
                                            10Y
                                          </option>
                                          <option value={"Since" + index}>
                                            Since Inception
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <div className="risk-factor-container">
                                      <div className="risk-factor">
                                        Riskometer:{" "}
                                        <span className="text-bold text-red">
                                          {risk}
                                          <span className="hover-img">
                                            <img
                                              src={info}
                                              alt=""
                                              aria-hidden="true"
                                            />
                                            <img
                                              src={riskimagehover}
                                              alt=""
                                              aria-hidden="true"
                                              className="riskimage-hover"
                                            />
                                          </span>
                                        </span>
                                      </div>
                                      <div>
                                        <div>
                                          <div
                                            id={`potentioal-risk-matrix-${SchemeCode}`}
                                            className="potentioal-risk-matrix"
                                            onMouseEnter={() =>
                                              setHovering(true)
                                            }
                                            onMouseLeave={() =>
                                              setHovering(false)
                                            }
                                            data-id={"s_" + SchemeCode}
                                            //onClick={handleShareButtonClick}
                                          >
                                            {(valuebtn === "debt" ||
                                              valuebtn === "fixed income") && (
                                              <p className="potentioal-hover">
                                                Potential Risk Class Matrix
                                              </p>
                                            )}
                                            {/* {showRiskMatrix && hovering && ( */}
                                            <div
                                              className="Risk-matrix-div"
                                              id={"d_" + SchemeCode}
                                              ref={socialIconsRef}
                                            >
                                              <h6>
                                                As per SEBI Circular dated, June
                                                07, 2021; the potential risk
                                                class (PRC) matrix based on
                                                interest rate risk and credit
                                                risk, is as follows:
                                              </h6>
                                              <div className="table-responsive">
                                                {/* <div>{(PrcRisk)}</div> */}
                                                <div
                                                  dangerouslySetInnerHTML={{
                                                    __html: PrcRisk,
                                                  }}
                                                />
                                                {/* <div> */}
                                              </div>
                                            </div>
                                            {/* )} */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="btn-container">
                                 
                                    <button
                                      className="button know-more-btn"
                                      onClick={clickGetSchemes}
                                      data-id={SchemeCode}
                                      data-type={categoryname}
                                      data-name={FundName}
                                      data-disc={PlanDesc}
                                      aria-label={`Know more about ${FundName}`}
                                    >
                                      Know More
                                    </button>
                               
                                    {/* <button
                                    className="button invest-btn"
                                    onClick={handleInvestButtonClick}
                                  >
                                    Invest
                                  </button> */}

                                    {/* <button type="button" className="button invest-btn" data-toggle="modal" data-target="#exampleModal">
                                    Invest
                                  </button> */}

                                    {/* <div className="modal-div-invest">
                                    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                      <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                          <div class="modal-body">
                                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                              <span aria-hidden="true">&times;</span>
                                            </button>
                                            <ul className='link-div-popup link-div-invest'>
                                              <li><img src={invester} alt="invester" /><a href='https://investor.jmfinancialmf.com/jmfinvestor/' target='_blank'>Investor</a></li>
                                              <li><img src={partner} alt="partner" /><a href='https://dit.jmfinancialmf.com/portal/login' target='_blank'>Partner</a></li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}

                                    {/* <img src={Download_share} id="shareButton" alt="" data-id={"s_" + srno} data-heading={heading} onClick={sendMassage} /> */}
                                    <button
                                      ref={investButtonRef}
                                      type="button"
                                      className="button invest-btn"
                                      data-id={"p_" + SchemeCode}
                                      onClick={sendMassage}
                                      aria-label={`Invest in ${FundName}`}
                                    >
                                      Invest
                                    </button>
                                    <div className="persocial-icons-perspective invest-link" ref={investDropdownRef}>
                                      <ul
                                        className="link-div-invest"
                                        id={"q_" + SchemeCode}
                                        ref={socialIconsRefinvest}
                                      >
                                        <li>
                                          {/* <img src={invester} alt="invester" /> */}
                                          <a
                                            href="https://investor.jmfinancialmf.com/jmfinvestor/"
                                            target="_blank"
                                            className="invest-option active"
                                          >
                                            Investor
                                          </a>
                                        </li>
                                        <li>
                                          {/* <img src={partner} alt="partner" /> */}
                                          <a
                                            href="https://dit.jmfinancialmf.com/portal/login"
                                            target="_blank"
                                            className="invest-option"
                                          >
                                            Partner
                                          </a> 
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ),
                            )}
                        </div>
                      </>
                      {/* )}
                        </div>
                      )} */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          {/* {loadingshow ? (
            <div className="textcentervertex">
              <img src={animation} alt="Loading" />
              <div className="model_popup">Please Wait...</div>
            </div>
          ) : (
            <>
            {(SearchText && !SearchData || SearchData.length === 0  ) && (
    <h6 className="errorMsg">No Data Found !!!</h6>
)}
            </>
          )} */}
        </section>
      </main>
    </>
  );
}

export default ProductSheme;
